<template>
	<r-standard-modal-form
		class="dropdown-options-modal-outter"
		:style="{
			height: `435px`,
			width: `264px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title"> Dropdown Choices </span>
		<div slot="body" class="dropdown-options-modal-body">
			<div class="input-header">Dropdown Choices for '{{ columnName }}'</div>
			<div class="options-container">
				<textarea 
					class="options-input"
					rows="5"
					name="options"
					:placeholder="`Separate choices onto new lines:\nIn Progress\nReady\nDone`"
					v-model="dropdownOptions"
				/>
			</div>
			<div class="multi-choice-container">
				<div class="input-header">Dropdown Type</div>
				<r-standard-selectfield
					slot="input"
					ref="weekStartsOn"
					placeholder="Allow choices"
					:field="multChoiceField"
					:choiceArray="multiChoiceChoices"
					:defaultToFirstOption="true"					
					:setValueMustBeInChoiceArray="true"
					:resetWhenChoiceArrayChanges="false"
					@updated="updateMultiChoice"
				>
				</r-standard-selectfield>
			</div>
			<r-button 
				:theme="buttonTheme" 
				fullWidth 
				class="submit-button" 
				@click="submit"
			>
				{{ buttonText }}
			</r-button>
			<div class="footer-container">
				<span>Dropdown choices can be added<br/>changed, or deleted at any time.</span>
			</div>
		</div>
	</r-standard-modal-form>
</template>
<script>

import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';

export default {
	name:'new-column-modal',
	data(){
		return{
			dropdownOptions: null,

			multChoiceField: {},			
		};
	},
	components:{
	},
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		fieldGUID:{
			required: true,
			type: String,
		}
	},
	mounted(){
		const focusable = this.$el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if(focusable[0] && focusable[0].focus){
			focusable[0].focus();
		}
	},
	computed:{
		schema(){
			return this.dataStore.meta.schema;
		},
		dataStore(){
			return this.sheetView.sheetViewGroup.dataStore;
		},
		columnName(){
			return this.schema.fields[this.fieldGUID].display.label;
		},
		dropdownOptionsFormatted(){
			if(this.dropdownOptions){
				return this.dropdownOptions.split("\n").map(function trimOptions(option){
					return option.trim();
				}).filter(function removeBlankOptions(option){
					return option.length > 0;
				});
			}
			return [];
		},
		buttonTheme(){
			return 'dark-blue';
			if(this.dropdownOptionsFormatted.length > 0){
				return 'dark-blue';
			}
			else{
				return 'white2';
			}
		},
		buttonText(){
			if (this.dropdownOptionsFormatted.length > 0) {
				return 'Add Dropdown Field';
			} else {
				return `Skip & Add Choices Later`;
			}
		},
		multiChoiceChoices(){
			return [{
				label: "One choice at a time",
				value: 'one',
			},{
				label: "Multiple choices at once",
				value: 'multiple',
			}];
		},
	},
	methods:{
		submit(){
			const vcSelf = this;
			vcSelf.$emit('closeModal');
			if(vcSelf.dropdownOptionsFormatted.length > 0){
				vcSelf.dropdownOptionsFormatted.forEach(function addAllOptions(picklistOption){
					vcSelf.dataStore.addPicklistValue(vcSelf.fieldGUID, picklistOption);
				});
			}
			if(vcSelf.multChoiceField.inputModelValue === 'multiple'){
				vcSelf.dataStore.changeFieldAttributeProperties(vcSelf.fieldGUID, {
					selectMultiple: true,
				});
			}
		},
		updateMultiChoice(){

		}
	},
}
</script>

<style scoped lang="scss">

.dropdown-options-modal-outter{
	width: 100%;

	.dropdown-options-modal-body{
		width: 100%;

		.input-header{
			font-family: $rvFontFamily;
			font-weight: 600;
			font-size: 13px;
			line-height: 19px;
			letter-spacing: 0.01em;
			color: $p-color-grey-400;
			margin-bottom: 6px;
		}

		.options-container{
			display: flex;

			.options-input{
				font-family: $rvFontFamily;
				font-weight: 500;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				color: $p-color-grey-600;
				padding: 10px 9px;
				border: 1px solid $p-color-grey-300;
				outline: none;
				width: 100%;
				resize: none;
				margin: 0;

				&:focus{
					border: 1px solid $p-color-grey-600;
				}
				@include placeholder;
			}
		}

		.multi-choice-container{
			padding-top: 18px;
		}

		.submit-button{
			margin-top: 33px;
		}

		.footer-container{
			font-family: Overpass;
			font-weight: 500;
			font-size: 13px;
			line-height: 19px;
			text-align: center;
			letter-spacing: 0.15px;
			color: $p-color-grey-500;
			margin-top: 18px;
		}
	}
}

</style>
